module.exports = __webpack_public_path__ + "img/女-糖尿病h.000bed2e.png";